// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'd55c46d1';
